import React from 'react';
import { Route } from 'react-router-dom';
import BlogTagsList from '../pages/blog/BlogTagsList';
import CreateBlogTag from '../pages/blog/CreateBlogTag';
import EditBlogTag from '../pages/blog/EditBlogTag';
import ProtectedRoute from '../components/global/ProtectedRoute';

const blogTagsRoutes = (
    <>
        <Route
            path="/blog/tags"
            element={
                <ProtectedRoute requiredPermission="blog-tags.view">
                    <BlogTagsList />
                </ProtectedRoute>
            }
        />
        <Route
            path="/blog/tags/create"
            element={
                <ProtectedRoute requiredPermission="blog-tags.create">
                    <CreateBlogTag />
                </ProtectedRoute>
            }
        />
        <Route
            path="/blog/tags/:id/edit"
            element={
                <ProtectedRoute requiredPermission="blog-tags.update">
                    <EditBlogTag />
                </ProtectedRoute>
            }
        />
    </>
);

export default blogTagsRoutes;
